// export const API_BASE = "http://192.168.0.57:5000/api";
export const API_BASE =
  process.env.REACT_APP_API_BASE || "http://localhost:5000/api";
